'use es6';

import PropTypes from 'prop-types';
import { Link } from 'foundations-components/transitional/components/Link';
import { buildSuggestedExchangeUrl } from '../../../utils/UrlBuilders';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const LANG_ROUTE = 'InboxConnectUtils.genericInboxForm.exchange';

/**
 * Handles error messaging for Exchange URL issues. Returns null when there is no error.
 * @internal
 * @param {{ validationMessages: Object, exchangeUrl: string, onSuggestionClick: (suggestedUrl: string) => void }}
 */
const ExchangeUrlErrorMessage = ({
  validationMessages,
  exchangeUrl,
  onSuggestionClick
}) => {
  // Server messaging takes precedence
  if (validationMessages.smtpHost) {
    return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: validationMessages.smtpHost
    });
  }
  if (validationMessages.exchangeUrlError) {
    const suggestedUrl = buildSuggestedExchangeUrl(exchangeUrl);
    return suggestedUrl ? /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: `${LANG_ROUTE}.urlAppearsToBeIncorrectSuggestion`,
      options: {
        suggestedUrl: /*#__PURE__*/_jsx(Link, {
          onClick: () => onSuggestionClick(suggestedUrl),
          children: suggestedUrl
        })
      }
    }) : /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: `${LANG_ROUTE}.urlAppearsToBeIncorrect`
    });
  }
  return null;
};
ExchangeUrlErrorMessage.propTypes = {
  validationMessages: PropTypes.object.isRequired,
  exchangeUrl: PropTypes.string.isRequired,
  onSuggestionClick: PropTypes.func.isRequired
};
export default ExchangeUrlErrorMessage;